import React from 'react';
import { DollarSign, CheckCircle, AlertCircle } from 'lucide-react';

const FinancialStatsCard = ({ inscription }) => {
  if (!inscription) {
    return null;
  }

  const formatAmount = (amount) => {
    if (typeof amount !== 'number') return '0';
    return amount.toLocaleString();
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Statistiques financières</h3>
      
      <div className="space-y-4">
        <div>
          <div className="flex justify-between text-sm text-gray-600 mb-1">
            <span>Montant total</span>
            <span className="font-medium">{formatAmount(inscription.montant_global)} FCFA</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-[#202654] h-2 rounded-full"
              style={{ width: `${inscription.progression_paiement}%` }}
            />
          </div>
        </div>

        <div className="flex justify-between text-sm">
          <div>
            <p className="text-gray-600">Montant payé</p>
            <p className="text-lg font-semibold text-green-600">
              {formatAmount(inscription.montant_paye)} FCFA
            </p>
          </div>
          <div className="text-right">
            <p className="text-gray-600">Reste à payer</p>
            <p className="text-lg font-semibold text-red-600">
              {formatAmount(inscription.montant_impaye)} FCFA
            </p>
          </div>
        </div>

        <div className="pt-4 border-t">
          <div className="flex justify-between items-center">
            <span className="text-gray-600">Progression</span>
            <span className={`text-lg font-semibold ${
              inscription.progression_paiement === 100 ? 'text-green-600' : 'text-[#202654]'
            }`}>
              {inscription.progression_paiement}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialStatsCard;
